module.exports = __webpack_public_path__ + "img/module-nothing.0d159285.png";